import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FA5B1F76-C0C4-4F08-B545-D28E78781F67
 * name drag-horizontal-variant
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/drag-horizontal-variant.svg
 * tags
 */
export const DragHorizontalVariantIcon = createSvgIcon(<><path d="M21 11H3V9H21V11M21 13H3V15H21V13Z" /></>, 'DragHorizontalVariantIcon');
export default DragHorizontalVariantIcon